export default __webpack_public_path__ + "static/media/circum.58f5bbee.png";